import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';

export const BadgeIcon = styled.img`
  margin-right: 7px;
  height: fit-content;
`;

export const FlexContainer = styled.div`
  padding: 0;
  margin: 0;
  list-style: none;
  -ms-box-orient: horizontal;
  display: flex;
`;

export const BadgeName = styled.span`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-style: normal;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  line-height: 18px;
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  margin-right: 12px;
  white-space: nowrap;
`;

export const ReactTooltipStyled = styled(ReactTooltip)`
  padding: 6px 10px !important;
  background-color: ${({ theme }) => theme.COLORS.NEUTRAL_30} !important;
  color: ${({ theme }) => theme.COLORS.BASE} !important;
`;
